import { createApp } from 'vue';
import App from './App.vue';
import store from '@/state';
import router from '@/routes';
import VueSweetalert2 from 'vue-sweetalert2';
import MaskInput from 'vue-mask-next';
import { setupGlobalErrorHandler } from '@/utils/errorHandler';

import 'sweetalert2/dist/sweetalert2.min.css';

const app = createApp(App);

setupGlobalErrorHandler(app);

app
    .use(store)
    .use(VueSweetalert2)
    .use(MaskInput)
    .use(router)
    .mount('#app');
